import * as React from "react";
import * as ReactDOM from "react-dom";
import { DestinationMiniMap, IDestinationMiniMap } from "./Map/MiniMap/destinationMiniMapProvider";
import { IMiniMap, MiniMap } from "./Map/MiniMap/miniMapProvider";
// import { IMammadabaMapProps, MammadabaMap } from "./Map/mapProvider";

/**
 * Renders route minimap on container. This method must be called every time you change MiniMap props, with the same container node
 * @param props Map props
 * @param container HTML div node
 */
export const renderMiniMap = (props: IMiniMap, container: HTMLDivElement): void => {
    ReactDOM.render(<MiniMap {...props} />, container);
};

/**
 * Renders destination minimap on container. This method must be called every time you change MiniMap props, with the same container node
 * @param props Map props
 * @param container HTML div node
 */
export const renderDestinationMiniMap = (props: IDestinationMiniMap, container: HTMLDivElement): void => {
    ReactDOM.render(<DestinationMiniMap {...props} />, container);
};

/**
 * Unmounts MiniMap component from the node.
 *
 * @param container HTML div node
 */
export const unmountMiniMap = (container: HTMLDivElement): void => {
    ReactDOM.unmountComponentAtNode(container);
};
